export default __webpack_public_path__ + "33f7e2fc06cc8db4423d9b04aefdeb43.svg";